export const restrictedFields = ['name', 'address'];
